import {
    initialStreamStatusesState,
    initialStreamStatusState,
    StreamStatus,
    StreamStatusesByStreamKey,
    StreamStatusesState,
    StreamStatusState,
} from 'streamsState/store/streamStatuses/StreamStatusesState';
import {
    StreamStatusAction,
    StreamStatusActionType,
} from 'streamsState/store/streamStatuses/actions';
import { Reducer } from 'redux';
import { reduceErrors } from 'streamsState/store/streamStatuses/StreamErrorState';
import omit from 'lodash/omit';

export const streamStatusesReducer: Reducer<
    StreamStatusesState,
    StreamStatusAction
> = (state = initialStreamStatusesState, action) => {
    switch (action.type) {
        case StreamStatusActionType.STREAM_STATUS_SET_PENDING:
            return reduceStreamStatusWithDelta(
                state,
                action.payload!.streamKey,
                {
                    channelId: action.payload!.channelId,
                    channelDestination: action.payload!.channelDestination,
                    status: StreamStatus.PENDING,
                    statusTime: new Date().getTime(),
                }
            );

        case StreamStatusActionType.STREAM_STATUS_SET_STREAMING:
            return reduceStreamStatusWithDelta(
                state,
                action.payload!.streamKey,
                {
                    status: StreamStatus.STREAMING,
                    statusTime: new Date().getTime(),
                }
            );

        case StreamStatusActionType.STREAM_STATUS_HANDLE_STREAM_ERROR:
            return reduceStreamStatus(
                state,
                action.payload!.streamKey,
                (s) => ({
                    ...s,
                    errors: reduceErrors(s.errors, action.payload!.error),
                })
            );

        case StreamStatusActionType.STREAM_STATUS_SET_STOPPED: {
            return reduceStreamStatusWithDelta(
                state,
                action.payload!.streamKey,
                {
                    status: StreamStatus.STOPPED,
                    statusTime: new Date().getTime(),
                }
            );
        }
        case StreamStatusActionType.STREAM_STATUS_HANDLE_ERROR: {
            return {
                ...state,
                errors: reduceErrors(state.errors, action.payload!.error),
            };
        }
        case StreamStatusActionType.STREAM_STATUS_REMOVE: {
            const nextState = { ...state };
            nextState.streams = omit(state.streams, action.payload!.streamKey);
            return nextState;
        }
    }
    return state!;
};

function reduceStreamStatusWithDelta(
    state: StreamStatusesState,
    streamKey: string,
    delta: Partial<StreamStatusState>
): StreamStatusesState {
    return reduceStreamStatus(state, streamKey, (s) => ({ ...s, ...delta }));
}

function reduceStreamStatus(
    state: StreamStatusesState,
    streamKey: string,
    reduce: (state: StreamStatusState) => StreamStatusState
): StreamStatusesState {
    const prevStreams: StreamStatusesByStreamKey = state.streams;
    const prevStreamState =
        state.streams[streamKey] || initialStreamStatusState;
    const newStreamState = reduce(prevStreamState);
    const nextStreamsState: StreamStatusesByStreamKey = {
        ...prevStreams,
        [streamKey]: newStreamState,
    };
    return { ...state, streams: nextStreamsState };
}
